import React, {useState} from 'react';
import CloseBtn from '../common/CloseIcon';
import {useDispatch, useSelector} from 'react-redux';
import {actionSendLink, resetPasswords, toggleModal} from '../../redux/actions';

import {RootState} from '../../redux/reducers';
import {useHistory} from 'react-router';

export const SendLink = () => {
    const dispatch = useDispatch();
    const closeModal = () => {
        dispatch(toggleModal());
    }


    // @ts-ignore @typescript-eslint/no-unused-vars
    const sendResult = useSelector((state:RootState) => state.resetLinkSent)

    if (sendResult && sendResult.message) {
        sendResult.message = `${sendResult.message}\nKui kiri ei ole e-postiga Sinuni jõudnud, võib see olla sattunud peakausta asemel mõnda muusse kausta (spämm, listikirjad, pakkumised).`
    }
    const doSendLink = async () => {
        const data = {
            email
        }
        dispatch(actionSendLink(data))
    }
    const [email, setEmail] = useState('');
    return <div>
        <div className='close-btn' onClick={closeModal}>
            <CloseBtn/>
        </div>
        <div className='login'>
            <h2 style={{marginTop:47,fontSize:'22px', fontWeight:'bold'}}>Saada parooli vahetamise link!</h2>
            <div>
                <div style={{padding: '30px'}}>{sendResult.message}</div>
                <div className="form-group">
                    <input
                        type="email"
                        className="form-control"
                        id="email"
                        value={email}
                        onChange={(ev)=>{setEmail(ev.target.value)}}
                        placeholder="email"/>
                </div>
                {sendResult.code ?
                    <button type="button" className="btn btn-success" onClick={closeModal}>Sulge</button> :
                    <button type="button" className="btn btn-success" onClick={doSendLink}>Saada</button>
                }

            </div>
            <div className='footerStart'/>
        </div>
    </div>
}

export const ChangePassword = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const closeModal = () => {
        dispatch(toggleModal());
        history.push('/');
    }
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');

    // @ts-ignore
    const sendResult = useSelector((state:RootState) => state.resetLinkSent)

    const validateForm = () => {
        if (!password) {
            setError('Parool on tühi! ')
            return false
        }
        if (password.length < 6 ) {
            setError('Parool on lühike, peaks olema vähemalt 6 tähte!')
            return false
        }
        if (password !== confirmPassword) {
            setError('Paroolid ei klapi')
            return false
        }
        setError('');
        return true
    }

    const doSubmit = async () => {
        if (validateForm()) {
            const data = {
                password
            }
            const result = await resetPasswords(data);
            if (result) {
                history.push('/');
                setError('Password was changed.')
            } else {
                history.push('/');
                setError('Viga! Küsi lisa kultuurikava toimetajatelt.')
            }
        }
    }

    return <div>
        <div className='close-btn' onClick={closeModal}>
        <CloseBtn/>
    </div>
        <div className='login'>
            <h2 style={{marginTop:47,fontSize:'22px', fontWeight:'bold'}}>Muuta oma parooli</h2>
            <div>
                { error ?
                    <div style={{padding: '30px', color: 'red'}}>{error}</div>:
                    null }

                <div className="form-group">
                    <input
                        type="password"
                        className="form-control"
                        id="password"
                        value={password}
                        onChange={(ev)=>{setPassword(ev.target.value);}}
                        placeholder="Uus parool"/>
                </div>
                <div className="form-group">
                    <input
                        type="password"
                        className="form-control"
                        id="confirm-password"
                        value={confirmPassword}
                        onChange={(ev)=>{setConfirmPassword(ev.target.value);}}
                        onBlur={validateForm}
                        placeholder="Korda parooli"/>
                </div>
                <button
                    type="button"
                    className="btn btn-success"
                    onClick={doSubmit}>
                    Saada
                </button>
            </div>
            <div className='footerStart'/>
        </div></div>
}


